const initialStateOrderType = {
  pages: [],
  ids: [],
  count: 0,
  ordersById: {},
  isFetching: false,
  isSubmitting: false,
  searchText: '',
  user: undefined,
  first_pickup_time: undefined,
  last_dropoff_time: undefined,
};

const initialStateOrderTypeForTest = {
  pages: [],
  ids: [],
  count: 0,
  ordersById: {},
  isFetching: false,
  isSubmitting: false,
  searchText: '',
  user: undefined,
  first_pickup_time: undefined,
  last_dropoff_time: undefined,
};

const initialState = {
  ...initialStateOrderType,
  filters: {},
};
export default initialState;
export { initialStateOrderTypeForTest, initialStateOrderType };
